import type { ControllerTool } from './registry';

/** What a controller tool shows until its port lands: honest, in production chrome. */
export function NotPorted({ tool }: { tool: Pick<ControllerTool, 'icon' | 'label'> }) {
  return (
    <div className="mm-not-ported">
      <div className="mm-not-ported-icon" dangerouslySetInnerHTML={{ __html: tool.icon }} />
      <h3>{tool.label}</h3>
      <p>{tool.label} has not been ported to Mighty Map yet. It is on the list and will open here when it is.</p>
    </div>
  );
}
